import classNames from 'classnames/bind';
import React from 'react';
import { Col, Form } from 'react-bootstrap';
import styles from './Steps.scss';

const cs = classNames.bind(styles);

export function StepsTypeFieldsSubType(props) {
  const {
    subType,
    handleChangeSteps,
    activeStepsFunc,
    stepClass,
    disabled,
    stepIndex,
    displayControl,
  } = props;

  if (displayControl !== true) {
    return null;
  }
  return (
    <Form.Group
      as={Col}
      controlId={`subType${stepIndex}`}
      className={cs('mb-0 px-1', 'd-block')}
    >
      <Form.Control
        disabled={disabled}
        size="sm"
        as="select"
        name={`steps[${stepIndex}][subType]`}
        value={subType || ''}
        onMouseDown={(e) => e.stopPropagation()}
        onFocus={() => activeStepsFunc(stepClass)}
        onChange={(e) => handleChangeSteps(e.target.value, stepIndex, 'subType')}
      >
        <option value="choices">choices</option>
        <option value="charts">charts</option>
        <option value="traits">traits</option>
      </Form.Control>
    </Form.Group>
  );
}
